import Constructor from '../constructor'
import Map from './module/map'

class Person extends Constructor(Map) {}

export default Person